import { Box, Flex } from "@chakra-ui/react";
import Image from "next/image";
import { useIntl } from "react-intl";
import { PARTNERS } from "../../../../constants/Partners";

export function Partners() {
  const intl = useIntl();

  return (
    <Flex wrap="wrap" justify="center" gap="1rem">
      {PARTNERS.map((partner, index) => (
        <Box
          key={index}
          flex="0 0 calc((100% - 4rem) / 5)"
          display="flex"
          justifyContent="center">
          <Image
            width={105}
            height={80}
            src={partner.src}
            alt={intl.formatMessage(partner.label)}
            loading="lazy"
          />
        </Box>
      ))}
    </Flex>
  );
}
